import type {GetExtraDeliveryListResponse} from './types';

import {createSlice} from '@reduxjs/toolkit';

import {extraDeliveryBuilder} from './reducer';

export type ExtraDeliveryPlanItem = {
  polygon_id: number;
  polygon_title: string;
  cost_per_order: number;
  cells: string[];
};

export type ExtraDeliveryState = {
  loading: boolean;
  list: GetExtraDeliveryListResponse | null;
  details: {
    id: number;
    start_date: string;
    end_date: string;
    state: string;
    activation_cost?: number;
  } | null;
  detailLoading: boolean;
  plans: {
    latitude: number;
    longitude: number;
    activation_cost: number;
    end_date: string;
    items: ExtraDeliveryPlanItem[];
  } | null;
  plansLoading: boolean;
  create: {
    loading: boolean;
  };
  confirm: {
    loading: boolean;
    result: {state: string; start_time: string; end_date: string} | null;
  };
  remove: {
    loading: boolean;
  };
  pause: {
    loading: boolean;
  };
};

const initialState: any = {
  loading: false,
  list: null,
  details: null,
  detailLoading: false,
  plans: null,
  plansLoading: false,
  create: {
    loading: false
  },
  confirm: {
    loading: false,
    result: null
  },
  remove: {
    loading: false
  },
  pause: {
    loading: false
  }
};

export const extraDeliverySlicer = createSlice({
  name: 'extraDelivery',
  initialState,
  reducers: {},
  extraReducers: extraDeliveryBuilder
});

export default extraDeliverySlicer.reducer;
